import type { ReactNode } from 'react'

import { Provider } from './employerAgreementIdContext'

type Props = {
  children: ReactNode
  employerAgreementId: string
}

export const EmployerAgreementIdProvider = ({
  children,
  employerAgreementId,
}: Props) => (
  <Provider
    value={{
      employerAgreementId,
    }}
  >
    {children}
  </Provider>
)
